// 前台数据
import axios from '@/http/index'

// 列出本人所有的文章
export const getList = (data) => {
    return axios({
        method: 'POST',
        url: '/api/list',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 删除文章
export const delList = (data) => {
    return axios({
        method: 'POST',
        url: '/api/info_del',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取解析状态及翻译状态
export const getStatus = (data) => {
    return axios({
        method: 'POST',
        url: '/api/status',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 新的会话
export const newChatApi = (data) => {
    return axios({
        method: 'POST',
        url: '/api/newchat',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取可用模型
export const getModel = (data) => {
    return axios({
        method: 'POST',
        url: '/api/getmodel',
		data
    })
}

// 学术智能问答
// 获取检索关键词(新提问第一步)
export const getkeyword = (data) => {
    return axios({
        method: 'POST',
        url: '/api/get_keyword',
		data,
		requestLoading: true,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 添加关键词  修改检索词
export const changeKeyword = (data) => {
    return axios({
        method: 'POST',
        url: '/api/add_keyword',
		data,
		requestLoading: true,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取检索结果,返回数量
export const getSearch = (data) => {
    return axios({
        method: 'POST',
        url: '/api/search',
		data,
		requestLoading: true,
    })
}

// 自定义文献的中文翻译
export const getSearchTran = (data) => {
    return axios({
        method: 'POST',
        url: '/api/search_tran',
		data,
		requestLoading: true,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 检索列表
export const getSearchList = (data) => {
    return axios({
        method: 'POST',
        url: '/api/search_list',
		data,
		requestLoading: true,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 删除检索
export const delSearch = (data) => {
    return axios({
        method: 'POST',
        url: '/api/search_del',
		data,
		requestLoading: true,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取引用（全部参考文献）
export const getReference = (data) => {
    return axios({
        method: 'POST',
        url: '/api/get_search_result',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取全文
export const getScihub = (data) => {
    return axios({
        method: 'POST',
        url: '/api/get_scihub',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取历史消息
export const getHistorysearch = (data) => {
    return axios({
        method: 'POST',
        url: '/api/search_msg',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 翻译文章
export const translatedArticle = (data) => {
    return axios({
        method: 'POST',
        url: '/api/translate',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 会话列表
export const getChatList = (data) => {
    return axios({
        method: 'POST',
        url: '/api/chatlist',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 消息内容
export const getMsgList = (data) => {
    return axios({
        method: 'POST',
        url: '/api/msglist',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 从书架来的文章
export const getFromscihub = (data) => {
    return axios({
        method: 'POST',
        url: '/api/fromscihub',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 编辑画图笔记
export const addCanvastNotes = (data) => {
    return axios({
        method: 'POST',
        url: '/api/update_canvast_notes',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取画图笔记
export const getCanvastNotes = (data) => {
    return axios({
        method: 'POST',
        url: '/api/get_canvas_notes',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 删除画图笔记
export const delCanvastNotes = (data) => {
    return axios({
        method: 'POST',
        url: '/api/del_canvas_notes',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 添加文档笔记
export const addDocumentNotes = (data) => {
    return axios({
        method: 'POST',
        url: '/api/add_document_notes',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}
// 获取文档笔记
export const getDocumentNotes = (data) => {
    return axios({
        method: 'POST',
        url: '/api/get_document_notes',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}
// 删除文档笔记
export const delDocumentNotes = (data) => {
    return axios({
        method: 'POST',
        url: '/api/del_document_notes',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}
// 编辑文档笔记
export const updateDocumentNotes = (data) => {
    return axios({
        method: 'POST',
        url: '/api/update_document_notes',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

//翻译
export const translatetextApi = (data) => {
    return axios({
        method: 'POST',
        url: '/api/translatetext',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 翻译Pdf
export const translatepdf = (data) => {
    return axios({
        method: 'POST',
        url: '/api/translatepdf',
		data,
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}

// 获取二次参文  回答和文献
export const checkRefererData = (params) => {
    return axios({
        method: 'POST',
        url: '/api/search_check_referer',
		params,
    })
}

// 获取 选中的自定义文献
export const getsearchresult = (params) => {
    return axios({
        method: 'POST',
        url: '/api/get_search_result',
		params,
    })
}